import axios, { AxiosResponse } from "axios";
import { Dictionary } from "../global/types";

export const logIn = async (email: string, password: string): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/auth`;
    const body = { email, password };
    return axios.post(url, body);
};

export const logOut = async (): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/logout`;
    return axios.post(url);
};

export const changePassword = async (data: Dictionary<string>): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/change_password`;
    return axios.post(url, data);
}

export const getAllCustomersData = async (data: Dictionary<string>): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/users`;
    return axios.get(url, { params: data });
}

export const getCustomerDetails = async (id: string): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/users/details/${id}`;
    return axios.get(url);
}

export const getAlarmDetails = async (id: string): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/alarms/details/${id}`;
    return axios.get(url);
}

export const getSettingsData = async (): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/settings`;
    return axios.get(url);
};

export const updateSettingsData = async (data: object): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/settings/update`;
    return axios.post(url, { data });
}

export const updateCustomerDetails = async (id: string, data: object): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/users/${id}`;
    return axios.post(url, { data });
}

export const getUserProfile = async (): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/profile`;
    return axios.get(url);
}

export const editUserProfile = async (name: string): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/profile/edit`;
    return axios.post(url, { name });
}

export const getAllAlarmsData = async (data: Dictionary<string>): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/alarms`;
    return axios.get(url, { params: data });
}

export const getAllMotiTagsData = async (data: Dictionary<string>): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/moti_tags`;
    return axios.get(url, { params: data });
}

export const uploadMotiTagsCSV = async (formData: FormData): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/moti_tags/upload_csv`;
    return axios.post(url, formData);
}

export const getAllUserFeedbackData = async (data: Dictionary<string>): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/user_feedback`;
    return axios.get(url, { params: data });
}

export const getAllLeaguesData = async (data: Dictionary<string>): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/leagues`;
    return axios.get(url, { params: data });
}

export const getLeagueDetails = async (id: string, date_filter?: number): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/leagues/details/${id}`;
    return axios.get(url, { params: { date_filter: date_filter || 1 } });
}

export const getLeagueStats = async (id: string, date_filter?: number, focus?: number): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/leagues/${id}/stats`;
    return axios.get(url, { params: { date_filter: date_filter || 1, league_focus: focus } });
}

export const getLeagueAssurancesHistory = async (id: string): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/leagues/${id}/assurances_history`;
    return axios.get(url);
}

export const getDashboardStatistics = async (): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/dashboard`;
    return axios.get(url);
};

export const getReportMatricsData = async (startDate?: Date, endDate?: Date, compareStart?: Date, compareEnd?: Date): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/reports/metrics`;
    return axios.get(url, { params: { startDate, endDate, compareStart, compareEnd } });
};

export const getReportAnalyticsData = async (startDate?: Date, endDate?: Date): Promise<AxiosResponse> => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/admin/reports/analytics`;
    return axios.get(url, { params: { startDate, endDate } });
};